<template lang="pug">
  v-dialog(
    v-model="showModal"
    persistent
    width="800px"
    content-class="modalStyle"
  )
    v-card(class="py-5 px-2")
      v-card.scroll
          v-flex.pa-2(
            id="gs-modal-installmentAccountOpeningDisclosure"
            xs12
            v-html="this.greenskyLegalContent.installmentAccountOpeningDisclosure"
          )
      v-flex(xs12 class="my-3 textAlign-left" id="gs-modal-disclosureTitle")
        strong {{ this.greenskyLegalContent.electronicConsentTitle }}
      v-flex(xs12 class="mb-2" id="gs-modal-checkbox")
        consent-checkbox(
          v-if="hasCoapplicant"
          :hasCoapplicant="true"
          @boxChecked="checkBox('electronicAccepted')"
          @coapplicantChecked="checkBox('electronicAcceptedCoapplicant')"
          :coapplicantAccepted="electronicAcceptedCoapplicant"
          :text="this.greenskyLegalContent.disclosureAcceptAppCoapp"
          id="gs-modal-coApplicantCheckbox"
        )
        consent-checkbox(
          v-else
          @boxChecked="checkBox('electronicAccepted')"
          :text="this.greenskyLegalContent.disclosureAcceptApp"
          id="gs-modal-applicantCheckbox"
        )
</template>

<script>
  import ConsentCheckbox from 'Components/ConsentCheckbox.vue'

  export default {
    name: 'ConsentStatementGreenskyModal',
    components: {
      ConsentCheckbox
    },
    props: {
      showModal: {
        type: Boolean,
        default: false
      },
      hasCoapplicant: {
        type: Boolean,
        default: false
      },
      greenskyLegalContent: {
        type: Object,
        default: () => null,
      },
      setElectronicAccepted: {
        type: Function,
        default: null
      }
    },
    data () {
      return {
        electronicAccepted: false,
        electronicAcceptedCoapplicant: false,
      }
    },
    methods: {
      checkBox(dataValue) {
        this.$data[dataValue] = !this.$data[dataValue]
        if(this.hasCoapplicant){
          if(this.electronicAccepted && this.electronicAcceptedCoapplicant){
            this.setElectronicAccepted()
          }
        } else if(this.electronicAccepted) {
          this.setElectronicAccepted()
        }
      },
    },
  }
</script>

<style scoped lang="scss">
  .modalStyle{
    max-width: 500px;
    min-width: 250px;
    width: 30rem;
    background-color: red;
  }
  .modal-button {
    width: 80%;
    max-width: 200px;
  }

  .heavy {
    font-weight: 600;
  }

  .pendingStyle{
   color: green;
  }

  .deniedStyle{
   color: rgb(149, 3, 3);
  }

  .textAlign-left{
   text-align: left;
  }
</style>
